export const initialState = JSON.parse(localStorage.getItem("authState")) || {
  jobs: [],
  user: null,
  isLoading: false,
};
